<template>
  <div class="d-flex justify-content-center">
    <b-row class="mt-3 col-12 col-lg-12 col-xl-12 social-networks-grid">
      <b-col class="col-12 text-center">
        <h1 class="mb-1">{{ $t('creator.titleNetworks') }}</h1>
        <p>{{ $t('creator.descriptionNetworks') }}</p>
      </b-col>
      <b-col 
        class="col-6 col-sm-4 col-md-3 col-lg-2 mt-3" 
        v-for="(network, index) in networks" 
        :key="index"
      >
        <card-social-network 
          :network="network" 
          :isSelected="isNetworkSelected(network)"
          @click="toggleNetwork(network)"
        />
      </b-col>
      <b-col class="col-12 d-flex justify-content-center">
        <compensations v-if="ready_networks" :networks_selected="selected" :invalid_networks="selected === null || selected.length === 0"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue';

export default {
  name: 'stepServiceOptions',
  components: {
    BRow,
    BCol,
    CardSocialNetwork: () => import('@/views/components/proposals/CardSocialNetwork.vue'),
    compensations: () => import('./stepCompensation.vue'),
  },
  data() {
    return {
      selected: [],
      steps: null,
      ready_networks: false,
      casting_call: {},
      networks: [
        { value: 'instagram', text: 'Instagram' },
        { value: 'tiktok', text: 'TikTok' },
        { value: 'twitch', text: 'Twitch' },
        { value: 'facebook', text: 'Facebook' },
        { value: 'linkedin', text: 'LinkedIn' },
        { value: 'spotify', text: 'Spotify' },
        { value: 'telegram', text: 'Telegram' },

        { value: 'youtube', text: 'YouTube' },
        { value: 'twitter', text: 'Twitter' },
        { value: 'snapchat', text: 'Snapchat' },
        { value: 'pinterest', text: 'Pinterest' },
        { value: 'blog', text: 'Blog' },
        { value: 'whatsapp', text: 'WhatsApp' },
        { value: 'reddit', text: 'Reddit' },
      ]
    }
  },
  created() {
    this.getData();
  },
  computed: {
    has_slug() {
      return this.$route.params.slug
    }
  },
  methods: {
    isNetworkSelected(network) {
      const isSelected = this.selected.find((item) => item === network.value) !== undefined;
      return isSelected;
    },
    toggleNetwork(network) {
      const index = this.selected.findIndex((item) => item === network.value);

      if (index === -1) this.selected.push(network.value);
      else this.selected.splice(index, 1);
    },
    getData() {
      if (this.has_slug) {
        console.log(this.$route.params.casting_call_data)
        this.casting_call = this.$route.params.casting_call_data;
        this.ready_networks = true;
        this.selected = this.casting_call.work_types ? this.casting_call.work_types.slice() : [];
      } else {
        this.steps = JSON.parse(localStorage.getItem('steps'));

        if (this.steps?.work_types) {
          this.selected = this.steps.work_types.slice();
        }
        this.ready_networks = true;
      }
    },
  },
}
</script>
<style>
.mt-3 {
  margin-top: 1rem !important;
}

@media (max-width: 576px) {
  .social-networks-grid .col-6 {
    margin-bottom: 1rem;
  }
}

@media (min-width: 992px) {
  .social-networks-grid .col-lg-2 {
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
}
</style>